import { hasTierWizard, WIZARD_PATH } from '@/config/membershipTierWizardSteps'

export const NEW_TIER_PATH = '/store/membership-tiers/new'

export const buildTierWizardGuards = getUser => ({
  newTier: to => (hasTierWizard(getUser()) ? { path: WIZARD_PATH, query: to.query } : true),
  wizard: to => (hasTierWizard(getUser()) ? true : { path: NEW_TIER_PATH, query: to.query })
})
